export default "__VITE_ASSET__CVjuOdAY__"